const CallBackTypes = {
  //**************CALLBACK FETCH  START********************/
  CALLBACK_FETCH_START: "callback_fetch_start",
  CALLBACK_FETCH_SUCCESS: "callback_fetch_success",
  CALLBACK_FETCH_FAILURE: "callback_fetch_failure",
  CALLBACK_FETCH_RESET_START: "callback_fetch_reset_start",
  CALLBACK_FETCH_CHANGED: "callback_fetch_changed",

  //**************CALLBACK FETCH  END********************/
  //**************CALLBACK EXPORT START********************/
  CALLBACK_EXPORT_START: "callback_export_start",
  CALLBACK_EXPORT_SUCCESS: "callback_export_success",
  CALLBACK_EXPORT_FAILURE: "callback_export_failure",
  CALLBACK_EXPORT_RESET_START: "callback_export_reset_start",
  CALLBACK_EXPORT_CHANGED: "callback_export_changed",
  //**************CALLBACK EXPORT END********************/
};
export default CallBackTypes;
